import { call, take, takeEvery } from 'redux-saga/effects';

import { getQcsSyncResources, qcsSyncCreateResource, qcsSyncUpdateResource, qcsSyncDeleteResource }
  from 'data/qcsSyncResourceSagaHelpers';
import { mkQcsSyncResourceConfig } from 'data/qcsSyncResourceTypes';

import { transformResponseToTrips, transformTripToRequestData } from 'data/trips/transformers';

import * as actions from './actions';
import { getLastSyncDate } from './selectors';


// ===============================================================================================
// SAGAS functions for trips.  These are the functions responsible for communicating directly
// with external endpoints asynchronously.

// ====================================================
// ACTION WATCHERS to trigger SAGAS calls

const mkResourceConfig = (successAction, failureAction) => mkQcsSyncResourceConfig({
  resourceName: 'trip',
  resourceBaseUrl: '/miles/trips',
  getLastSyncDate,

  transformResponseToResources: transformResponseToTrips,
  transformResourceToRequestData: transformTripToRequestData,

  successAction,
  failureAction,
});

export function* getTripsActionWatcher() {
  // using a vanilla saga pattern so we only process a single get request
  //   - takeEvery would process every request
  //   - takeLatest would cancel any current request and start request again
  while (true) {
    const action = yield take(actions.getTrips);

    const config = mkResourceConfig(actions.getTripsSuccess, actions.getTripsFailure);
    yield call(getQcsSyncResources, config, action);
  }
}

export function* createTripActionWatcher() {
  const config = mkResourceConfig(actions.createTripSuccess, actions.createTripFailure);
  yield takeEvery(actions.createTrip, qcsSyncCreateResource, config);
}

export function* updateTripActionWatcher() {
  const config = mkResourceConfig(actions.updateTripSuccess, actions.updateTripFailure);
  yield takeEvery(actions.updateTrip, qcsSyncUpdateResource, config);
}

export function* deleteTripActionWatcher() {
  const config = mkResourceConfig(actions.deleteTripSuccess, actions.deleteTripFailure);
  yield takeEvery(actions.deleteTrip, qcsSyncDeleteResource, config);
}

// ====================================================
// EXPORTS

export default [
  getTripsActionWatcher,
  createTripActionWatcher,
  updateTripActionWatcher,
  deleteTripActionWatcher,
];
